import { render, staticRenderFns } from "./salesByDealerRing.vue?vue&type=template&id=8b8be34e"
import script from "./salesByDealerRing.vue?vue&type=script&lang=js"
export * from "./salesByDealerRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports